<template>
  <div class="mobileHead" id="head">
    <img
      src="@/assets/images/logo.png"
      alt=""
      class="logo"
      @click="backEvent"
    />
    <img
      src="@/assets/images/icon_more.png"
      alt=""
      class="menu"
      @click="menuEvent"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: "",
    };
  },
  created() {
    this.getPath();
  },
  methods: {
    getPath() {
      console.log(window.location.pathname);
      this.path = window.location.pathname;
    },
    menuEvent() {
      this.$router.push({
        path: "/menu",
      });
    },
    backEvent() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
.mobileHead {
  width: 100%;
  height: 90px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0px 0px 5px #b4b4b4;
  z-index: 9999;
  .logo {
    width: 166px;
    height: 44px;
    margin-left: 40px;
  }
  .menu {
    width: 38px;
    height: 38px;
    margin-right: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicCom/mobileHead.vue